import React from "react";
import { Table } from "reactstrap";
import { constructSquadMemberList } from "./util";

export function ReviewData(props) {
  const {
    squadMembers,
    organization,
    contactName,
    phone,
    email,
    due,
    locationName,
    locationAddress,
    locationCity,
    locationState,
    locationZip
  } = props.request;

  const memberText = constructSquadMemberList(squadMembers);

  return (
    <div>
      <p>Please review your request before submitting:</p>
      <Table>
        <tbody>
          <tr>
            <th scope="row">Contact Name:</th>
            <td>{contactName.val}</td>
          </tr>
          <tr>
            <th scope="row">Email:</th>
            <td>{email.val}</td>
          </tr>
          <tr>
            <th scope="row">Phone:</th>
            <td>{phone.val}</td>
          </tr>
          <tr>
            <th scope="row">Organization:</th>
            <td>{organization.val}</td>
          </tr>
          <tr>
            <th scope="row">Due Date:</th>
            <td>{due.val.format("lll")}</td>
          </tr>
          <tr>
            <th scope="row">Spirit Members:</th>
            <td>{memberText}</td>
          </tr>
          <tr>
            <th scope="row">Address:</th>
            <td>
              {locationName.val}
              <br />
              {locationAddress.val}
              <br />
              {`${locationCity.val}, ${locationState.val} ${locationZip.val}`}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

// function constructSquadMemberList({ costume, live, cheer, crockett }) {
//   const membersList = [
//     costume ? "Smokey (costume)" : null,
//     live ? "Smokey (live)" : null,
//     cheer ? "Cheer/dance team" : null,
//     crockett ? "Davy Crockett" : null
//   ];

//   let memberText = "";

//   membersList.forEach(member => {
//     if (member) {
//       memberText += memberText.length !== 0 ? `, ${member}` : member;
//     }
//   });

//   return memberText;
// }

// ReviewData.propTypes = {
//   request: PropTypes.shape({
//     name: PropTypes.shape({
//       val: PropTypes.string.isRequired,
//       isValid: PropTypes.bool
//     }),
//     email: PropTypes.shape({
//       val: PropTypes.string.isRequired,
//       isValid: PropTypes.bool
//     }),
//     title: PropTypes.shape({
//       val: PropTypes.string.isRequired,
//       isValid: PropTypes.bool
//     }),
//     type: PropTypes.shape({
//       val: PropTypes.string.isRequired,
//       isValid: PropTypes.bool
//     }),
//     due: PropTypes.shape({
//       val: PropTypes.object.isRequired,
//       isValid: PropTypes.bool
//     }),
//     description: PropTypes.shape({
//       val: PropTypes.string.isRequired,
//       isValid: PropTypes.bool
//     })
//   })
// };

ReviewData.displayName = "ReviewData";



// WEBPACK FOOTER //
// ./src/Spirit/ReviewData.jsx